
// Servicios.js
import React from 'react';
import { motion } from 'framer-motion';
//imagenes
import cardBajaMediaTensionImg from '../assets/card_img/card_MediaTension.png';
import cardInstIndustrialesImg from '../assets/card_img/card_MediaTension.png';
import cardLicitaciones from '../assets/card_img/card_licitaciones.png';

import CardText from './CardText';

const Services = () => {
  const servicesData = [
    {
      title: 'Baja y Media Tensión', description: 'Diseño y desarrollo de proyectos en BT [220-380]V y MT [13,2 - 33]kV aéreos y subterráneos.', link: '#business',
      coverImage: cardBajaMediaTensionImg, content: (
        <>
          <h5 className="text-lg ">Detalles Técnicos</h5>
          <p>Los proyectos de baja y/o media tensión incluyen:</p>
          <ul className="text-left list-disc pl-5">
            <li>Estudios preliminares.</li>
            <li>Gestión y diseño de proyectos eléctricos.</li>
            <li>Optimización de sistemas de distribución.</li>
            <li>Cálculos eléctricos y mecánicos.</li>
            <li>Diseño de líneas de distribución.</li>
            <li>Elaboración de cómputos métricos.</li>
            <li>Diagnóstico de redes eléctricas.</li>
          </ul>

          </>
      ),
    },

    { title: 'Instalaciones Electricas Industriales', description: 'Diseño y desarrollo de instalaciones electricas en naves industriales.',
      coverImage: cardInstIndustrialesImg, content: (
        <>
          <h5 className="text-lg ">Detalles Técnicos</h5>
          <p>Los proyectos incluyen:</p>
          <ul className="text-left list-disc pl-5">
            <li>Evaluación de las necesidades energéticas de la nave.</li>
            <li>Desarrollo de planes electricos, con optimizacion en el rendimiendo.</li>
            <li>Diseño e instalacion de sistemas de distribucion electrica interna y externa.</li>
            <li>Diseño e implementación de iluminacion industrial.</li>
            <li>Instalacion de sistemas de protección.</li>
            <li>Integracion con sistemas automatizados.</li>
          </ul>
        </>
      ),
     },
    { title: 'Asesoramiento Licitatorios', description: 'Servicio integral de asesoramiento licitatorio enfocado en obras eléctricas.',
      coverImage: cardLicitaciones, content: (
        <>
          <h5 className="text-lg ">Detalles Técnicos</h5>
          <p>El asesoramiento licitatorio incluyen:</p>
          <ul className="text-left list-disc pl-5">
            <li>Evaluación de condiciones técnicas y administrativas.</li>
            <li>Identificación de requerimientos críticos.</li>
            <li>Verificación del cumplimiento normativo.</li>
            <li>Elaboración detallada de cómputos métricos.</li>
            <li>Redacción de pliegos para obras de distribución.</li>
            <li>Especificaciones técnicas para líneas aéreas y subterráneas.</li>
            <li>Creación de cronogramas y planes de trabajo.</li>
            <li>Asesoramiento en la presentación de ofertas.</li>
          </ul>
        </>
      ),
     },

    
    { title: 'Energías Renovables', description: 'Soluciones integrales que promueven la sostenibilidad, optimizan el uso de recursos naturales y reducen los costos energéticos.',
      coverImage: cardBajaMediaTensionImg, content: (
        <>
          <h5 className="text-lg ">Detalles Técnicos</h5>
          <p>Los proyectos de enerías renovables incluyen:</p>
          <ul className="text-left list-disc pl-5">
            <li>Diseño de sistemas solares fotovoltaicos.</li>
            <li>Soluciones híbridas combinando tecnologías renovables.</li>
            <li>Análisis técnico-económico de proyectos renovables.</li>
            <li>Dimensionamiento de sistemas según necesidades energéticas.</li>
            <li>Análisis de rendimiento y eficiencia energética.</li>
            <li>Integración de sistemas de almacenamiento de energía.</li>
          </ul>
          </>
      ),
     },

  
    

  ];

  return (
    <motion.section
      id="servicesElect"
      className="pt-20 pb-10"
      style={{ backgroundColor: 'var(--background-color-typeA)' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="container mx-auto px-4 text-center">
        <h3 className="text-3xl mb-12">Ingeniería Electromecánica </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 px-[10%] gap-5 col-auto">
          {servicesData.map((feature, index) => (
            <div key={index} className="flex flex-col">
              <CardText
                title={feature.title}
                description={feature.description}
                link={feature.link}
                content={feature.content}
                coverImage={feature.coverImage}

              ></CardText>

            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Services;